import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CareRecipient, RevokeResponse } from '@app/core/api/care-links';

export const CareActions = createActionGroup({
  source: 'Care',
  events: {
    // Load care recipients
    'Load Care Recipients': emptyProps(),
    'Load Care Recipients Success': props<{ careRecipients: CareRecipient[] }>(),
    'Load Care Recipients Failure': props<{ error: string }>(),

    // Revoke link (unlink from app user)
    'Revoke Link': props<{ linkId: string }>(),
    'Revoke Link Success': props<{ response: RevokeResponse }>(),
    'Revoke Link Failure': props<{ error: string }>(),

    // Select recipient for analytics
    'Select Recipient': props<{ userId: string }>(),

    // Clear state (on logout)
    'Clear Care State': emptyProps(),
  }
});
